module.exports = __webpack_public_path__ + "img/expenditureItemIcon5.51080837.png";